import { useEffect } from 'react';

export const useBeforeWindowUnload = (beforeunload: (e: BeforeUnloadEvent) => any) => {
  useEffect(() => {
    window.addEventListener('beforeunload', beforeunload);
    return () => {
      window.removeEventListener('beforeunload', beforeunload);
    };
  }, [beforeunload]);
};
